import React, { useEffect, useState } from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Legend, ResponsiveContainer, Tooltip } from "recharts";
import axios from "axios";
import { urlAPI_Current } from '../config';
import { userLogged } from '../userLogged';

import styles from "../styles/resultQuestionary.module.css";

export function TriangularRadarChart({ userId }) {
    const [userData, setUserData] = useState({});
    const [tipoPerfil, setTipoPerfil] = useState("");
    const [maxCognitivo, setMaxCognitivo] = useState(0);
    const [minCognitivo, setMinCognitivo] = useState(0);
    const [maxRelacional, setMaxRelacional] = useState(0);
    const [minRelacional, setMinRelacional] = useState(0);
    const [maxSocioemocional, setMaxSocioemocional] = useState(0);
    const [minSocioemocional, setMinSocioemocional] = useState(0);

    async function getUserLogged(){
        try {
            const user = await userLogged();
            if (user) {
                setUserData(user);
                verificarQualPerfil(user);
            }
        } catch (error) {
            console.error("Erro ao obter dados do usuário:", error);
        }
    }

    function verificarQualPerfil(userData){
        if(!userData) return;
        
        const cognitivo = userData.pontuacao_cognitivo;
        const relacional = userData.pontuacao_relacional;
        const socioemocional = userData.pontuacao_socioemocional;

        const maior = Math.max(cognitivo, relacional, socioemocional);

        // Verifica empates com base na prioridade definida pelo Luis no grupo
        if (
            cognitivo === relacional &&
            cognitivo === maior
        ) {
            setTipoPerfil("Cognitivo");
            setMaxCognitivo(120);
            setMinCognitivo(98);
            setMaxRelacional(80);
            setMinRelacional(58);
            setMaxSocioemocional(30);
            setMinSocioemocional(20);
        } else if (
            cognitivo === socioemocional &&
            cognitivo === maior
        ) {
            setTipoPerfil("Cognitivo");
            setMaxCognitivo(120);
            setMinCognitivo(98);
            setMaxRelacional(80);
            setMinRelacional(58);
            setMaxSocioemocional(30);
            setMinSocioemocional(20);
        } else if (
            relacional === socioemocional &&
            relacional === maior
        ) {
            setTipoPerfil("Relacional");
            setMaxCognitivo(80);
            setMinCognitivo(58);
            setMaxRelacional(120);
            setMinRelacional(98);
            setMaxSocioemocional(30);
            setMinSocioemocional(20);
        } else if (cognitivo === maior) { // se não empatar em nada, pega só maior mesmo
            setTipoPerfil("Cognitivo");
            setMaxCognitivo(120);
            setMinCognitivo(98);
            setMaxRelacional(80);
            setMinRelacional(58);
            setMaxSocioemocional(30);
            setMinSocioemocional(20);
        } else if (relacional === maior) {
            setTipoPerfil("Relacional");
            setMaxCognitivo(80);
            setMinCognitivo(58);
            setMaxRelacional(120);
            setMinRelacional(98);
            setMaxSocioemocional(30);
            setMinSocioemocional(20);
        } else if (socioemocional === maior) {
            setTipoPerfil("SocioEmocional");
            setMaxCognitivo(30);
            setMinCognitivo(20);
            setMaxRelacional(80);
            setMinRelacional(58);
            setMaxSocioemocional(120);
            setMinSocioemocional(98);
        } else {
            console.error("Erro ao verificar qual perfil para gráfico");
        }
    }

    const data = [
        {
            subject: "Cognitivo",
            IDEAL: maxCognitivo,
            REAL: minCognitivo,
            userScore: userData?.pontuacao_cognitivo || 0,
        },
        {
            subject: "Relacional", 
            IDEAL: maxRelacional,
            REAL: minRelacional,
            userScore: userData?.pontuacao_relacional || 0,
        },
        {
            subject: "Sócioemocional",
            IDEAL: maxSocioemocional,
            REAL: minSocioemocional,
            userScore: userData?.pontuacao_socioemocional || 0,
        }
    ];

    useEffect(() => {
        getUserLogged();
    }, []);

    if (!userData || Object.keys(userData).length === 0) {
        return <div>Carregando...</div>;
    }

    return (
        <div id="RadarChart" className={styles.radarChart} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <div className={styles.chartContainer} style={{ width: '410px', height: '300px' }}>
                <ResponsiveContainer width="100%" height="100%">
                    <RadarChart className={styles.chart} outerRadius="80%" data={data}>
                        <PolarGrid />
                        <PolarAngleAxis 
                            dataKey="subject" 
                            tick={{ fontSize: 14}}
                            dy={-10} 
                        />
                        <PolarRadiusAxis 
                            angle={90} 
                            domain={[0, 120]} 
                            tickCount={7} 
                            tickFormatter={(tick) => `${tick}`}
                        />
                        <Radar
                            name="IDEAL"
                            dataKey="IDEAL"
                            stroke="#8884d8"
                            fill="#8884d8"
                            fillOpacity={0.6}
                        />
                        <Radar
                            name="REAL"
                            dataKey="REAL"
                            stroke="#ff7300"
                            fill="#ff7300"
                            fillOpacity={0.6}
                        />
                        <Radar
                            name={userData.nome ? userData.nome.toUpperCase() : 'User'} 
                            dataKey="userScore"
                            stroke="#82ca9d"
                            fill="#82ca9d"
                            fillOpacity={0.6}
                        />
                        <Legend
                            layout="horizontal"
                            verticalAlign="bottom"
                            align="center"
                        />
                        <Tooltip formatter={(tick) => `${tick}`}/>
                    </RadarChart>
                </ResponsiveContainer>
            </div>
            <div className={styles.legendResults} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: '16px' }}>
        <p className={styles.chartSubtitle}>Resultado: </p>
        <ul>
        {data.map((item, index) => (
            <div key={index}>
                <li >{item.subject}: {item.userScore}</li>
            </div>
        ))}
        </ul>
    </div>
        </div>
    );
}